module.exports = __webpack_public_path__ + "static/img/service-bag@2x.167a958a.png";